import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { VaultLedgerViewComponent } from './components/vault-ledger-view/vault-ledger-view.component';
import { VaultService } from './services/vault.service';
import { VaultConsoleComponent } from './components/vault-console/vault-console.component';
import { VaultPayComponent } from './components/vault-pay/vault-pay.component';
import { VaultReceiveComponent } from './components/vault-receive/vault-receive.component';
import { VaultPayListComponent } from './components/vault-pay/vault-pay-list/vault-pay-list.component';
import { VaultPayAddupdateComponent } from './components/vault-pay/vault-pay-addupdate/vault-pay-addupdate.component';
import { CommoncomponentsModule } from '../common-components/common-components.module';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { MenubarModule } from 'primeng/menubar';
import { SidebarModule } from 'primeng/sidebar';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { NgSelectModule } from '@ng-select/ng-select';
import { VaultReceiveAddupdateComponent } from './components/vault-receive/vault-receive-addupdate/vault-receive-addupdate.component';
import { VaultReceiveListComponent } from './components/vault-receive/vault-receive-list/vault-receive-list.component';
import { SharedModule } from "../shared/shared.module";
import { InputSwitchModule } from 'primeng/inputswitch';

@NgModule({
    declarations: [
        VaultLedgerViewComponent,
        VaultConsoleComponent,
        VaultPayComponent,
        VaultReceiveComponent,
        VaultPayListComponent,
        VaultPayAddupdateComponent,
        VaultReceiveAddupdateComponent,
        VaultReceiveListComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        CommoncomponentsModule,
        NgSelectModule,

        FormsModule,
        ButtonModule,
        DropdownModule,
        CheckboxModule,
        MenubarModule,
        SidebarModule,
        DialogModule,
        CalendarModule,
        SharedModule,
        InputSwitchModule
    ],
    exports: [
        VaultConsoleComponent,
    ],
    providers: [VaultService]
})

export class VaultModule { }
